export default class Trabalho {
  constructor(id, sgcq, nome, codigo, fabricante, dimensoes, peso, carga, observacao, servico) {
    this.id = id;
    this.sgcq = sgcq;
    this.nome = nome;
    this.codigo = codigo;
    this.fabricante = fabricante;
    this.dimensoes = dimensoes;
    this.peso = peso;
    this.carga = carga;
    this.observacao = observacao;
    this.servico = servico;
  }

  update(trabalho) {
    this.id = trabalho.id;
    this.sgcq = trabalho.sgcq;
    this.nome = trabalho.nome;
    this.codigo = trabalho.codigo;
    this.fabricante = trabalho.fabricante;
    this.dimensoes = trabalho.dimensoes;
    this.peso = trabalho.peso;
    this.carga = trabalho.carga;
    this.observacao = trabalho.observacao;
    this.servico = trabalho.servico;
    this.atividade = trabalho.atividade;
  }
}
